export default class ShopSellingPlan extends HTMLElement {
    private open = false
    private itemSellingPlanId: string
    private itemIndex: number
    private quantity: number

    private buttons: HTMLButtonElement[] = []
    private list: HTMLUListElement
    private caret: HTMLSpanElement

    constructor() {
        super()

        this.itemSellingPlanId = this.getAttribute('item-selling-plan-id')!
        this.itemIndex = parseInt(this.getAttribute('item-index')!)
        this.quantity = parseInt(this.getAttribute('quantity')!)

        this.open = this.getAttribute('open') === 'true'

        this.list = this.querySelector('[data-list]')!
        this.buttons = Array.from(this.querySelectorAll('[data-button]'))
        this.caret = this.querySelector('[data-caret]')!
    }

    connectedCallback() {
        if (this.buttons) {
            this.buttons.forEach((button) => {
                button?.addEventListener('click', this.handleButtonClick.bind(this))
            })
        }
    }

    set isOpen(value: boolean) {
        this.open = value
        this.toggle()
    }

    get isOpen() {
        return this.open
    }

    private handleButtonClick = (evt: Event) => {
        evt.preventDefault()
        evt.stopPropagation()

        this.isOpen = !this.isOpen

        if (this.isOpen) {
            return
        }

        const target = evt.target as HTMLInputElement

        const sellingPlanId = target.getAttribute('data-selling-plan-id')

        // check if this is a different selling plan
        const isNewSellingPlan = this.itemSellingPlanId !== sellingPlanId

        if (!isNewSellingPlan) {
            return
        }

        // update the list and put the selected item in at the top
        const selectedItem = this.list.querySelector(`[data-item-value="${sellingPlanId}"]`)

        if (selectedItem) {
            // this.list.insertBefore(selectedItem, this.list.firstChild)

            const sellingPlan = sellingPlanId != '' ? sellingPlanId : null

            const update = {
                line: this.itemIndex,
                quantity: this.quantity,
                selling_plan: sellingPlan,
            }

            // @ts-ignore
            if (window?.liquidAjaxCart?.init) {
                // @ts-ignore
                window?.liquidAjaxCart?.change(update, { important: true })
            }
        }

        // update URL
        setTimeout(() => {
            if (sellingPlanId) {
                // window.location.href = url
            }
        }, 10)
    }

    private toggle() {
        // update the attributes

        this.setAttribute('open', this.isOpen ? 'true' : 'false')
        this.list.setAttribute('data-open', this.isOpen ? 'true' : 'false')

        if (this.isOpen) {
            this.classList.add('!z-50')
            this.list.classList.add('!h-auto')
            this.caret.classList.add('rotate-180')
        } else {
            this.classList.remove('!z-50')
            this.list.classList.remove('!h-auto')
            this.caret.classList.remove('rotate-180')
            this.list.scrollTo({ top: 0 })
        }
    }
}

customElements.define('shop-selling-plan', ShopSellingPlan)
